/** Format wallet totals disclaimer, e.g. "SINCE 5 JULY 2026". */
export function formatTotalsTrackedSinceDisclaimer(dateStr: string): string {
  const d = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(d.getTime())) return "SINCE CLARITY ONE LAUNCH";
  const formatted = d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return `SINCE ${formatted.toUpperCase()}`;
}

export function formatClarityOnePhone(contact: string | null | undefined): string {
  const digits = (contact ?? "").replace(/\D/g, "");
  if (digits.length === 8) return `+65 ${digits.slice(0, 4)} ${digits.slice(4)}`;
  if (digits.startsWith("65") && digits.length === 10) {
    return `+65 ${digits.slice(2, 6)} ${digits.slice(6)}`;
  }
  return contact?.trim() || "—";
}
